import { render, staticRenderFns } from "./MenuPreview.vue?vue&type=template&id=5f1a96e0&"
import script from "./MenuPreview.vue?vue&type=script&lang=js&"
export * from "./MenuPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports